import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star } from 'lucide-react';
import { Section, CHECKOUT_URL } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" glow className="bg-brand-surfaceLight/70 rounded-3xl my-12 border border-brand-gold/30 shadow-[0_0_60px_rgba(201,153,47,0.18)]" data-id="element-272">
      <div className="text-center mb-10 relative" data-id="element-273">
        <span className="inline-flex items-center gap-2 bg-brand-purple text-white text-[11px] md:text-sm font-bold tracking-wider uppercase px-4 py-1.5 rounded-full mb-4 shadow-[0_0_20px_rgba(180,90,52,0.45)] animate-glow-pulse" data-id="element-274">
          ✨ Oferta de lanzamiento
        </span>
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-purpleDark" data-id="element-275">
          TU <span className="headline-shine" data-id="element-276">MEGA PACK CHI KUNG</span>
        </h2>
        <p className="text-brand-text/70 mt-3 text-sm md:text-base" data-id="element-277">
          ⏰ El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-278">
        <div className="relative rounded-2xl md:rounded-3xl" data-id="element-279">
          <span className="glow-frame" aria-hidden="true" data-id="element-280" />
          <div className="relative z-[1] w-full text-left rounded-2xl md:rounded-3xl p-4 md:p-6 bg-white/95 backdrop-blur-sm shadow-[0_0_48px_rgba(180,90,52,0.30)]" data-id="element-281">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-282">
              <div className="flex-1 min-w-0" data-id="element-283">
                <div className="flex items-center gap-1.5 mb-1.5 text-brand-purple" data-id="element-284">
                  <Trophy className="w-4 h-4 fill-brand-purple" data-id="element-285" />
                  <Star className="w-3.5 h-3.5 fill-brand-purple" data-id="element-286" />
                  <span className="text-[10px] md:text-sm font-bold tracking-wider uppercase" data-id="element-287">
                    El sistema más completo
                  </span>
                </div>

                <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-288">
                  <div className="min-w-0" data-id="element-289">
                    <h3 className="font-serif font-bold text-sm md:text-lg text-brand-purpleDark leading-tight" data-id="element-290">
                      <span className="mr-1.5" data-id="element-291">🏆</span>
                      MEGA PACK CHI KUNG™
                    </h3>
                    <p className="text-xs md:text-sm text-brand-text/70 mt-1" data-id="element-292">
                      3 Tomos + 6 Bonus · Más de 190 páginas
                    </p>
                    <p className="text-[11px] md:text-sm text-brand-purple font-medium mt-1.5" data-id="element-293">
                      El sistema integral de sesiones pre-diseñadas y blindaje
                      para el terapeuta profesional
                    </p>
                  </div>

                  <div className="text-right shrink-0 mt-4 md:mt-0" data-id="element-294">
                    <p className="text-xs md:text-sm text-brand-text/40 line-through leading-none" data-id="element-295">
                      $95.000 ARS
                    </p>
                    <p className="font-serif font-bold text-lg md:text-2xl leading-tight mt-1 text-brand-purple" data-id="element-296">
                      $24.990 ARS
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} animate={{
        scale: [1, 1.025, 1],
        y: [0, -2, 0]
      }} transition={{
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }} whileHover={{
        scale: 1.04,
        y: -3,
        transition: {
          duration: 0.25
        }
      }} whileTap={{
        scale: 0.98
      }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 md:py-6 text-base md:text-xl font-bold text-white purple-gradient-bg rounded-full animate-glow-pulse relative overflow-hidden cta-shimmer shadow-[0_0_34px_rgba(192,117,42,0.55)]" data-id="element-297">
          <span className="relative z-10" data-id="element-298">→ QUIERO MI MEGA PACK $24.990</span>
        </motion.a>

        <p className="text-center text-xs md:text-sm text-brand-text/60 pt-2" data-id="element-299">
          🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳
          Mercado Pago
        </p>
      </div>
    </Section>;
};